import { useState, useEffect } from "react";
import { TableCell } from "./TableCell";

export function TextEditCell({
  value,
  valueType = "string",
  onChangeValue,
  infotext = undefined,
  type = "string",
}) {
  const [ownValue, setOwnValue] = useState(value);
  const [oldValue, setOldValue] = useState(value);
  const [valid, setValid] = useState(true);

  useEffect(() => {
    if (type === "number") {
      let result = Number(ownValue);
      if (isNaN(result)) {
        setValid(false);
        return;
      }
    }
    setValid(true);
    if (ownValue != oldValue) onChangeValue(valueType === "number" ? Number(ownValue) : ownValue);
  }, [ownValue]);

  return (
    <TableCell>
      <input
        style={{ color: valid ? "black" : "red" }}
        type={valueType === "number" ? "number" : "text"}
        value={ownValue}
        placeholder={infotext}
        onChange={(e) => {
          setOwnValue(e.target.value);
        }}
      />
    </TableCell>
  );
}
